// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__3YW5T","tab":"TabNav_tab__2GfQq","link":"TabNav_link__Ph2Zs","selectedLink":"TabNav_selectedLink__318di","disabled":"TabNav_disabled__7LbjN"};